import CustomTextArea from '@/components/antd-comp/input/CustomTextArea'
import { customFetch, isFetchSseResponse } from '@/controllers/request'
import { showMessage } from '@/components/antd-comp/message'
import ThemeBtn from '@/components/antd-comp/theme-btn'
import { useDictStore } from '@/store/dictStore'
import { useBuriedEvent } from '@/util/buried'
import { LoadingOutlined } from '@ant-design/icons'
import { Button, Input, Modal, Select } from 'antd'
import { throttle } from 'lodash'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import IconUpload from '../../../components/antd-comp/icon-upload'
import { createAssistantsApi } from '../../../controllers/API/assistant'
import '../css/styles.css'

/* 创建应用弹窗 */
const CreateApplication = ({
  open,
  setOpen,
  dropList,
  obj,
  onSave,
  dataSource = [],
  /* ai构建 =
   'default' 
   'aiBuild'
   'template'
   'self'
   'picture'
   'chat'
   'knowledge'
   undefined 
   模型广场 = modelSquare
   应用编排 = '' = default
   */
  modelType = 'default',
  tool_ids = [],
  onlyChat = 0 as any,
  /* 传递的模型名称 - 模型广场 */
  modelName = ''
}) => {
  // ------埋点------
  const { applicationBuriedEvent, aiBuildBuriedEvent, modelSquareBuriedEvent } = useBuriedEvent()
  /* 取消 */
  const handleCancel = (e: React.MouseEvent<HTMLElement>) => {
    // 判断是否来自AI构建场景（modelType 不为 'default' 表示来自AI构建）
    // const isFromAiBuild = modelType && modelType !== 'default'
    if (modelType === 'modelSquare') {
      // 模型广场的取消埋点
      modelSquareBuriedEvent({
        event_name: '【取消】按钮',
        page: '模型广场页面',
        detail: JSON.stringify({ 操作: '取消创建Agent' })
      })
    } else if (modelType === 'default') {
      // 普通应用创建场景的取消埋点
      applicationBuriedEvent({
        page: obj?.id ? '编辑Agent弹窗' : '创建Agent弹窗',
        event_name: '【取消】按钮',
        data_id: obj.id
      })
    } else {
      // AI构建场景的取消埋点
      aiBuildBuriedEvent({
        event_name: '【取消】按钮',
        page: 'AI构建页面',
        detail: JSON.stringify({ 构建类型: modelType, 操作: '取消创建应用' })
      })
    }

    setOpen(false)
    setFormData({ name: '', desc: '', logo: '', category_code: '', id: '' })
  }
  const { t } = useTranslation()
  // State for form fields
  const [formData, setFormData] = useState({
    name: '',
    desc: '',
    logo: '',
    category_code: '',
    id: ''
  })

  useEffect(() => {
    setFormData({
      ...formData,
      ...obj
    })
    if (obj.id) {
      const editData = {
        ...formData,
        ...obj,
        category_code: obj.category_code ? Number(obj.category_code) : null
      }
      setFormData(editData)
      // 编辑时，验证默认传入的数据
      const formErrors = {}
      Object.keys(editData).forEach(key => {
        const error = validateField(key, editData[key])
        if (error) {
          formErrors[key] = error
        }
      })
      setErrors(formErrors)
    }
  }, [])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(false)
  }, [])
  // State for errors
  const [errors, setErrors] = useState<any>({})

  // Validate form fields
  const validateField = (name, value) => {
    switch (name) {
      case 'name':
        if (!value || !value.trim()) return t('build.nameRequired')
        if (value.length > 16) return '名称最多16个字符'
        return ''
      case 'category_code':
        if (!value) return t('build.category_codeRequired')
        return ''
      case 'desc':
        // if (value.length > 500) return t('build.forBetter')
        if (value && value.length < 20) return t('application.promptForBetter')
        return ''
      default:
        return ''
    }
  }

  const generateAiValidateField = (name, value) => {
    switch (name) {
      case 'name':
        if (!value) return t('build.nameRequired')
        if (value.length > 16) return '名称最多16个字符'
        return ''
      case 'desc':
        if (!value) return 'AI生成icon时描述不能为空'
        return ''
      default:
        return ''
    }
  }

  const generateAiValidateForm = () => {
    const formErrors = {}
    let isValid = true
    Object.keys(formData).forEach(key => {
      const error = generateAiValidateField(key, formData[key])
      if (error) {
        formErrors[key] = error
        isValid = false
      }
    })
    setErrors(formErrors)
    return isValid
  }

  // Handle field change
  const handleChange = (e, type) => {
    const error = validateField(type, e)
    setErrors(prev => ({ ...prev, [type]: error }))
    if (type === 'name') {
      setFormData(prev => ({ ...prev, name: e.trim() }))
    } else if (type === 'category_code') {
      setFormData(prev => ({ ...prev, category_code: e }))
    } else if (type === 'desc') {
      setFormData(prev => ({ ...prev, desc: e.trim() }))
    }
  }

  // Validate entire form
  const validateForm = () => {
    const formErrors = {}
    let isValid = true
    Object.keys(formData).forEach(key => {
      const error = validateField(key, formData[key])
      if (error) {
        formErrors[key] = error
        isValid = false
      }
    })
    setErrors(formErrors)
    return isValid
  }
  const { loadDictOptions } = useDictStore()
  // Handle form submission
  const navigate = useNavigate()
  // 异步函数来获取默认Logo
  const defLogoFun = async () => {
    try {
      const res = await loadDictOptions('icon')
      if (res && res.length) {
        return res[Math.floor(Math.random() * res.length)].value
      }
    } catch (error) {
      console.error('Error loading dict options:', error)
    }
  }
  /* 提交 */
  const handleSubmit = async e => {
    e.preventDefault()
    const isValid = validateForm()
    if (isValid) {
      setLoading(true)
      if (formData?.id) {
        onSave(formData)
        return
      }
      /* 没有选择就获取默认logo */
      let logo = formData.logo
      if (!formData.logo) {
        logo = await defLogoFun()
      }
      createAssistantsApi(
        formData.name,
        formData.desc,
        logo,
        formData.category_code,
        tool_ids,
        onlyChat,
        modelName || ''
      )
        .then((res: any) => {
          if (res) {
            // 判断是否来自AI构建场景（modelType 不为 'default' 表示来自AI构建）
            // const isFromAiBuild = modelType && modelType !== 'default'
            if (modelType === 'modelSquare') {
              // 模型广场的提交埋点（成功）
              modelSquareBuriedEvent({
                event_name: '【确定】按钮',
                page: '模型广场页面',
                data_id: res.id,
                detail: JSON.stringify({ 类型: formData.category_code, 结果: '成功' })
              })
            } else if (modelType === 'default') {
              // 普通应用创建场景的提交埋点（成功）
              applicationBuriedEvent({
                page: '创建Agent弹窗',
                event_name: '【确定】按钮',
                data_id: res.id,
                detail: JSON.stringify({ 类型: formData.category_code, 结果: '成功' })
              })
            } else {
              // AI构建场景的提交埋点（成功）
              aiBuildBuriedEvent({
                event_name: '【提交】按钮',
                page: 'AI构建页面',
                data_id: res.id,
                detail: JSON.stringify({ 构建类型: modelType, 类型: formData.category_code, 结果: '成功' })
              })
            }
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            window.assistantCreate = true // 标记新建助手
            /* 引导判断 */
            if (dataSource.length === 0) {
              localStorage.setItem('applicationEditCreate', '1')
            }
            navigate('/applicationEdit/' + res.id, { state: { modelType } })
          }
        })
        .catch(() => {
          // 判断是否来自AI构建场景（modelType 不为 'default' 表示来自AI构建）
          // const isFromAiBuild = modelType && modelType !== 'default'
          if (modelType === 'modelSquare') {
            // 模型广场的取消埋点
            modelSquareBuriedEvent({
              event_name: '【确定】按钮',
              page: '模型广场页面',
              detail: JSON.stringify({ 类型: formData.category_code, 结果: '失败' })
            })
          } else if (modelType === 'default') {
            // 普通应用创建场景的提交埋点（失败）
            applicationBuriedEvent({
              page: '创建应用弹窗',
              event_name: '【确定】按钮',
              detail: JSON.stringify({ 类型: formData.category_code, 结果: '失败' })
            })
          } else {
            // AI构建场景的提交埋点（失败）
            aiBuildBuriedEvent({
              event_name: '【提交】按钮',
              page: 'AI构建页面',
              detail: JSON.stringify({ 构建类型: modelType, 类型: formData.category_code, 结果: '失败' })
            })
          }
          setLoading(false)
        })
    }
  }
  /**
   * ICON上传组件相关
   */
  const [iconFileList] = useState([])
  const handleSelectPic = pic => {
    setFormData(prev => ({ ...prev, logo: pic }))
  }

  /* ai优化描述 */
  let [optimizeLoading, setOptimizeLoading] = useState(false)
  const esLinkSuccess = useRef(false)
  const updateOptimizeInfo = throttle(list => {
    setFormData(prev => ({ ...prev, desc: list.join('') }))
    // 同步重新校验 desc
    // const error = validateField('desc', list.join(''))
    // setErrors(prev => ({ ...prev, desc: error }))
  }, 100)
  // 优化完成后进行校验
  const validateAfterOptimize = () => {
    setFormData(prev => {
      const error = validateField('desc', prev.desc)
      setErrors(prevErrors => ({ ...prevErrors, desc: error }))
      return prev
    })
  }
  // 优化
  const optimizeFun = e => {
    e.preventDefault()
    setOptimizeLoading(true)
    setErrors(prev => ({ ...prev, desc: '' })) // 清除错误提示-字数
    handleOptimizeReq(formData.desc)
  }
  const handleOptimizeReq = async prompt => {
    esLinkSuccess.current = false
    try {
      const apiUrl = `/api/v1/assistant/optimize?prompt=${encodeURIComponent(prompt)}&category=AppDescribe&text=${
        formData.name
      }`
      const eventSource = new EventSource(apiUrl, { withCredentials: true })
      const msgList = []
      eventSource.onmessage = event => {
        if (!event.data) {
          setOptimizeLoading(false)
          validateAfterOptimize() // 优化完成后进行校验
          return
        }

        esLinkSuccess.current = true
        const parsedData = JSON.parse(event.data)
        if (parsedData?.status && parsedData.status == 30) {
          updateOptimizeInfo(
            parsedData?.choices[0]?.delta?.content
              ? [parsedData.choices[0].delta.content]
              : [
                  '大模型advice:作为一名AI语言模型，我不能回答涉及色情、暴力、政治等敏感话题的问题。如果您有其他相关问题，请重新提问。'
                ]
          )
          return
        }
        switch (parsedData.type) {
          case 'prompt':
            msgList.push(parsedData.message)
            updateOptimizeInfo(msgList)
            break
          case 'error':
            updateOptimizeInfo([])
            showMessage({
              type: 'error',
              content: parsedData.message
            })
            setOptimizeLoading(false)
            validateAfterOptimize() // 优化完成后进行校验
            break
          case 'end':
            setOptimizeLoading(false)
            validateAfterOptimize() // 优化完成后进行校验
            if (parsedData.message) {
              showMessage({
                content: parsedData.message,
                type: 'error'
              })
            }
            break
        }
      }
      eventSource.onerror = async (error: any) => {
        eventSource.close()
        if (error.data || !esLinkSuccess.current) {
          /* 判断合规451 */
          const preCheckResponse = await customFetch(apiUrl, { method: 'GET' })
          if (isFetchSseResponse(preCheckResponse)) {
            console.log('text/event-stream')
          } else {
            // 处理不合规的内容情况 = 451
            const jsonResponse = await preCheckResponse.json()
            if (jsonResponse.status_code === 451 || jsonResponse.status_code === 500) {
              showMessage({
                content: jsonResponse.status_message || '内容不合规，请重新操作',
                type: 'warning'
              })
              setOptimizeLoading(false)
              validateAfterOptimize() // 优化完成后进行校验
              return
            }
          }
          let msg = '优化失败'
          if (error.data) {
            msg = JSON.parse(error.data)
          }
          showMessage({
            content: msg,
            type: 'error'
          })
        }
        setOptimizeLoading(false)
        validateAfterOptimize() // 优化完成后进行校验
      }
    } catch (error) {
      setOptimizeLoading(false)
      validateAfterOptimize() // 优化完成后进行校验
    }
  }

  return (
    <>
      <Modal
        width={825}
        className="modal_antcomp_case"
        title={formData?.id ? t('application.appliPageDiaTitleEdit') : t('application.appliPageDiaTitle')}
        open={open}
        // style={{ top: '10%' }}
        onCancel={handleCancel}
        centered
        maskClosable={false}
        footer={[
          <Button
            key="cancel"
            className="closeBtnStyles closeBtnWid h-[34px] w-[108px]"
            shape="round"
            onClick={handleCancel}
          >
            {t('cancel')}
          </Button>,
          <ThemeBtn key="create" disabled={loading} className="closeBtnWid h-[34px] w-[108px]" onClick={handleSubmit}>
            {loading && <LoadingOutlined className="mr-2" />}
            确定
          </ThemeBtn>
        ]}
      >
        <div
          style={{ overflowY: 'scroll', height: '616px' }}
          className="flex flex-col gap-4 py-2 pr-1 sm:max-w-[825px]"
        >
          {/* name */}
          <div className="">
            <label htmlFor="name" className="bisheng-label">
              {t('application.appliPageDiaName')}
              <span className="bisheng-tip">*</span>
            </label>
            <Input
              id="name"
              name="name"
              autoComplete="off"
              placeholder="给Agent取个名字，16个字符以内"
              className="inputHig contMarginTop"
              value={formData.name}
              onChange={e => handleChange(e.target.value, 'name')}
            />
            {errors.name && <p className="bisheng-tip mt-1">{errors.name}</p>}
          </div>
          {/* type */}
          <div className="caseMarginTop">
            <label htmlFor="category_code" className="bisheng-label">
              {t('application.appliPageDiaType')}
              <span className="bisheng-tip">*</span>
            </label>
            <div className="contMarginTop">
              <Select
                key={'createApplication_select'}
                className="inoutHig"
                placeholder={t('application.appliPageDiaType')}
                value={formData.category_code ? formData.category_code : null}
                style={{ width: '100%' }}
                onChange={val => handleChange(val, 'category_code')}
                options={dropList}
                fieldNames={{ label: 'label', value: 'id' }}
              />
            </div>
            {errors.category_code && <p className="bisheng-tip mt-1">{errors.category_code}</p>}
          </div>
          {/* desc */}
          <div className="caseMarginTop">
            <div className="flexRowStart flexRowJustBet">
              <label htmlFor="desc" className="bisheng-label">
                {t('application.appliPageDiadesc')}
              </label>
              <Button
                loading={!!optimizeLoading}
                type="primary"
                size="small"
                disabled={!formData.name}
                className="appli_desc_btn"
                style={{
                  background: !formData.name ? '#ccc' : '#5964F3'
                }}
                onClick={optimizeFun}
              >
                AI润色
              </Button>
            </div>
            <div className=" application_prompt_optimize_textarea relative min-h-32">
              <CustomTextArea
                id="desc"
                name="desc"
                placeholder={t('application.appliPageDiadescDef')}
                maxLength={200}
                className="contMarginTop min-h-32"
                value={formData.desc}
                onChange={e => {
                  handleChange(e.target.value, 'desc')
                }}
              />
            </div>

            {errors.desc && <p className="bisheng-tip mt-1">{errors.desc}</p>}
          </div>
          {/* icon */}
          <div className="caseMarginTop">
            <IconUpload
              defaultFileList={iconFileList}
              logo={formData.logo}
              name={formData.name}
              description={formData.desc}
              validateMethod={generateAiValidateForm}
              onSelect={pic => handleSelectPic(pic)}
            ></IconUpload>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateApplication
